var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "clientesConectaDetalle" }, [
    _c(
      "div",
      {
        staticClass: "gridcard rounded-card",
        staticStyle: { padding: "2rem", "background-color": "white" }
      },
      [
        _c(
          "v-flex",
          { attrs: { sm4: "", md4: "" } },
          [
            _c("v-text-field", {
              attrs: { label: "Buscar...", "single-line": "" },
              on: { input: _vm.onFilterTextBoxChanged },
              model: {
                value: _vm.search,
                callback: function($$v) {
                  _vm.search = $$v
                },
                expression: "search"
              }
            })
          ],
          1
        ),
        _c("ag-grid-vue", {
          staticClass: "ag-theme-material",
          staticStyle: { "font-family": "'Asap', sans-serif" },
          attrs: { gridOptions: _vm.gridOptions }
        })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }